<template>
	<div>
		<!-- <Header1></Header1>
		<Index11></Index11>
		<Footer></Footer> -->
		<Header></Header>
		<Index11></Index11>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from '@/components/Header.vue'
import Header1 from '@/components/Header1.vue'
import Index from '@/components/index/Index.vue'
import Footer from '@/components/Footer.vue'
import Index11 from '@/components/index/Index.vue'
import Footer1 from '@/components/Footer1.vue'
export default {
	components: {
		Header,
		// Index,
		Footer,
		// Header1,
		Index11,
		// Footer1
	},
}
</script>

<style>
@import url('../../assets/css/style.css');
</style>



// WEBPACK FOOTER //
// src/views/index/Index.vue